import Highcharts = require("highcharts");
import { LineSerie } from "./line.serie";
import { Component, OnInit, Inject } from "@angular/core";
import { DashboardDataService } from "../core/dashboarddataservice";

@Component({
    selector: "crew-person-competences-status-graph",
    template: require('./person-competences-status-graph-component.html')
})
export class PersonsCompetencesStatusGraphComponent implements OnInit {
    constructor(
        @Inject("$log") private $log: ng.ILogService,
        private dashboardDataService: DashboardDataService) {
    }

    ngOnInit() {
        this.dashboardDataService
            .searchDayCompetencesStatus({ Day: null, Name: null, Value: null, Color: null })
            .then(res => {

                var data: LineSerie[] = [];
                for (var i = 0; i < res.length; i++) {

                    var dataPoint = res[i];
                    data.push({ name: dataPoint.Name, y: dataPoint.Value, color: dataPoint.Color });
                }

                this.refreshGraph(data);
            })
            .catch(err => this.$log.error(err));
    }

    private refreshGraph(dataSource: LineSerie[]) {

        // Build the chart
        Highcharts.chart('person-competencesstatus-graph', {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            title: {
                text: 'Person Competences Status'
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    innerSize: 170,
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            credits: {
                enabled: false
            },
            series: [{
                name: 'Competence Status',
                colorByPoint: true,
                data: dataSource
            }]
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/dashboard/person-competences-status-graph-component.ts